// ink-component
import React, { HTMLProps } from 'react';

import getGlobalProps from '../../../../helpers/constants/global-props';

import Row from '../../../Grid/Row/Row';

export interface PageBodyProps extends HTMLProps<HTMLDivElement> {}

const globalProps = getGlobalProps({});

/**
 * @purpose Arranges page content and sidebar
 * @group Page
 */
function PageBody(props: PageBodyProps) {
  const { className, style, children, ...otherProps } = props;

  return (
    <div {...otherProps} {...globalProps}>
      <Row>{children}</Row>
    </div>
  );
}

PageBody.displayName = 'Page.Body';

export default PageBody;
